import { TECHNICAL_ADMINISTRATOR, PROJECT_MANAGER, USER, CCE, ELECTED } from '@/lib/enums/user/role'
import Option from '@/lib/transfer-objects/Option'
import Filter from '@/lib/transfer-objects/Filter'

const keyValues = {
  [TECHNICAL_ADMINISTRATOR]: 'Administrateur',
  [PROJECT_MANAGER]: 'Chef de Projet / Exploitation',
  [CCE]: 'CCE',
  [USER]: 'Utilisateur',
  [ELECTED]: 'Elu'
}

var options = []
for (var key in keyValues) {
  options.push(new Option(keyValues[key], key))
}
var filter = new Filter({options: options})
var select = new Filter({firstOptionText: 'Sélectionner un profil', options: options})

export {keyValues as userRole, filter as userRolesFilter, select as userRolesSelect}



// WEBPACK FOOTER //
// ./src/lib/filters/user/role.js